// extracted by mini-css-extract-plugin
export default {"popper":"FilterRentalTypes_popper__tNzoD","root":"FilterRentalTypes_root__4j9r1"};